"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChooseEmailDomain = void 0;
const react_1 = __importDefault(require("react"));
const theme_1 = require("../utils/theme");
const misc_1 = require("../utils/misc");
const css_manager_1 = require("@food/css-manager");
const Button_1 = require("@food/ui/build/dist/src/Button");
const Radio_1 = require("@food/ui/build/dist/src/Radio");
const sectionClass = (0, css_manager_1.registerClass)((theme, sc) => `
	.${sc('spaced-bottom')} {
		margin-bottom: ${theme.ratios.l * theme.font.baseSize}px;
	}
	
	.${sc('ul')} > * {
		padding-bottom: ${theme.ratios.l}em;
	}

`);
const sc = (0, css_manager_1.currySC)(sectionClass);
const ChooseEmailDomain = ({ t, emailDomains, emailDomain, onChoose, emailDomainChooser, supportEmail, }) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("h2", null, t `Choose your company`),
    react_1.default.createElement("section", { className: sectionClass },
        react_1.default.createElement("div", { className: sc('spaced-bottom') },
            t `Thanks for validating`,
            "!"),
        react_1.default.createElement("div", null, t `Your email domain is associated with more than a company, please confirm which you work for:`),
        emailDomains.length > 1 && (react_1.default.createElement("div", { className: sc('li') }, emailDomains.map((i) => (react_1.default.createElement(Radio_1.Radio, { key: i.id, label: (0, misc_1.emailDomainLabel)(i), checked: i.id === emailDomain, onChange: () => emailDomainChooser(i) }))))),
        react_1.default.createElement("p", null,
            t `If your branch is not one of the options, please select your headquarter and then let us know by writing to our support email:`,
            react_1.default.createElement("a", { href: 'mailto:' + supportEmail },
                " ",
                supportEmail)),
        react_1.default.createElement("div", { className: (0, css_manager_1.cns)(theme_1.footer, (0, css_manager_1.subClass)(theme_1.footer, 'centered')) },
            react_1.default.createElement(Button_1.Button, { label: t `Confirm`, type: "success", disabled: !emailDomain, onClick: () => onChoose() })))));
exports.ChooseEmailDomain = ChooseEmailDomain;
//# sourceMappingURL=ChooseEmailDomain.js.map